/** Parse Retry-After without allowing an infinite deadline. */
export function guestRetryDelayMs(value: string | null): number {
  if (!value || !value.trim()) return 60_000;
  if (/^\d+$/.test(value.trim())) {
    const seconds = Number(value);
    return Number.isSafeInteger(seconds) && seconds <= 86400 ? seconds * 1000 : 86400_000;
  }
  const date = Date.parse(value);
  return Number.isFinite(date) && !/^[-+\d]/.test(value.trim())
    ? Math.min(86400_000, Math.max(0, date - Date.now())) : 60_000;
}

export function newIdempotencyKey(op: string): string {
  const rid = (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `web-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  return `msapling:${op}:${rid}`;
}
